import React from "react";
import PropTypes from "prop-types";
import { GRAY_500 } from "../../../constant/colors";

const InlineEditEmptyPlaceholder = ({ text, testId }) => (
  <span
    data-testid={testId}
    style={{
      color: GRAY_500,
      fontWeight: "normal",
      whiteSpace: "nowrap",
      display: "inline-block"
    }}
  >
    {text || "—"}
  </span>
);

InlineEditEmptyPlaceholder.propTypes = {
  text: PropTypes.string,
  testId: PropTypes.string
};

export default InlineEditEmptyPlaceholder;
